"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FontStyle;
(function (FontStyle) {
    FontStyle["Normal"] = "ty-font-normal";
    FontStyle["Italic"] = "ty-font-italic";
    FontStyle["Oblique"] = "ty-font-oblique";
    FontStyle["Initial"] = "ty-font-intial";
    FontStyle["Inherit"] = "ty-font-inherit";
})(FontStyle = exports.FontStyle || (exports.FontStyle = {}));
